const HG = window.HG || (window.HG = {});
const $ = window.jQuery;
window.$ = $;

class GetQuotesModal {
  init() {
    $(() => {
      $('#gqModalBtn').on('click', (e) => {
        e.preventDefault();
        const element = document.getElementById('gqModal');
        const category = window.catObj || undefined;
        const location = $('#heroGetQuotes  .hero__gq-postcode__input').val() || '';
        window.GQModal.open(element, category, location);
      });
    });
  }
}

HG.GetQuotesModal = new GetQuotesModal();
HG.GetQuotesModal.init();



// WEBPACK FOOTER //
// ./get-quotes/scripts/ab-main.js